export default __webpack_public_path__ + "static/media/TFE_desktop_homepage_image.be497bca.jpg";